import LoginResponse from '@/models/LoginResponse';

export interface AuthState {
    token: string | null;
    userInformations: LoginResponse | null;
    isOldLogin: boolean;
    isLoading: boolean;
}

export interface  AuthenticationParameters {
    login?: string;
    password?: string;
    tokenAzure?: string;
    mail?: string;
    compteId?: number;
}

export interface  CreationCompteParametres {
    nom: string;
    prenom: string;
    mail: string;
    entreprise?: string;
    numeroTelephone?: number;
    nomSociete?: string;
    ville?: string;
    siren?: string;
    civilite?: string;
    fonction?: string;
    consultationFactures?: boolean;
}

export const initialState: AuthState = {
    token: '',
    userInformations: null,
    isOldLogin: false,
    isLoading: false,
};

export const state: AuthState = {
    ...initialState,
};

